// extracted by mini-css-extract-plugin
export default {"columns":"columns_columns__Tfk2Q","hoverarea":"columns_hoverarea__oy7Vb","column":"columns_column__aywbF","active":"columns_active__5-ErI","col_value":"columns_col_value__g2Kkv"};